import {
  LOGICAL_MODEL_MEASURE,
  LOGICAL_MODEL_MEASURE_GROUP,
  LOGICAL_MODEL_DIMENSION_DATA_ACCESS,
  LOGICAL_MODEL_DIMENSION_HIERARCHY_ACCESS,
  LOGICAL_MODEL_DIMENSION,
  LOGICAL_MODEL_DIMENSION_ATTRIBUTE_ACCESS
} from './constants';
import { IResourceType } from '../../models/Policies/PolicyContract';

export const selectRoleSearch = (state: { role: any; }) => state.role.searchValue
export const selectRoles = (state: { role: any; }) => {
  if (state.role && state.role.roleList !== undefined)
    return state.role.roleList
  else
    return state.role;
}
export const selectNoRole = (state: { role: any; }) => state.role.noRoles
export const selectRoleOfSubject = (state: { role: any; }) => {
  if (state.role && state.role.rolesOfSubject !== undefined)
    return state.role.rolesOfSubject;
  else
    return state.role;
}
export const selectAllFilteredRoles = (state: { role: any; }) => state.role.filteredRoles;
export const selectSelectedRoleItem = (state: { role: any; }) => state.role.selectedRoleItem;
const selectResourceTypeActions = (state: { role: any; }, resourceTypeName: string) => {
  const resourceType: IResourceType | undefined = state.role.policyResourceTypes[resourceTypeName];

  if (!resourceType) {
    return [];
  }

  return resourceType.actionIds.map(actionId => state.role.dataPlatformActions[actionId]);
};
export const selectDataAccessActions = (state: { role: any; }) =>
  selectResourceTypeActions(state, LOGICAL_MODEL_DIMENSION_DATA_ACCESS);
export const selectAttributeAccessActions = (state: { role: any; }) =>
  selectResourceTypeActions(state, LOGICAL_MODEL_DIMENSION_ATTRIBUTE_ACCESS);
export const selectHierarchyAccessActions = (state: { role: any; }) =>
  selectResourceTypeActions(state, LOGICAL_MODEL_DIMENSION_HIERARCHY_ACCESS);
export const selectDimensionAccessActions = (state: { role: any; }) =>
  selectResourceTypeActions(state, LOGICAL_MODEL_DIMENSION);
export const selectMeasuresPolicyActions = (state: { role: any; }) =>
  selectResourceTypeActions(state, LOGICAL_MODEL_MEASURE);
export const selectMeasuresGroupPolicyActions = (state: { role: any; }) =>
  selectResourceTypeActions(state, LOGICAL_MODEL_MEASURE_GROUP);
export const selectExported = (state: { role: any; }) => state.role.rolesExported;
//export const selectExportedLoader = (state: { role: any; }) => state.role.exportLoader;
//export const selectError = (state: { role: any; }) => state.role.error;
